import React from 'react';
import { Filter } from 'lucide-react';

interface ReportHeaderProps {
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
  fromDate: string;
  toDate: string;
  onFromDateChange: (date: string) => void;
  onToDateChange: (date: string) => void;
  onApplyFilter: () => void;
  beforeDateContent?: React.ReactNode;
  children?: React.ReactNode;
}

const ReportHeader: React.FC<ReportHeaderProps> = ({
  title,
  subtitle,
  icon,
  fromDate,
  toDate,
  onFromDateChange,
  onToDateChange,
  onApplyFilter,
  beforeDateContent,
  children
}) => {
  return (
    <div className="bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-700 sticky top-0 z-10">
      {/* Match sidebar header height: p-4 with same content structure */}
      <div className="p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            {icon && (
              <div className="bg-brandColor p-2 rounded-lg">
                {icon}
              </div>
            )}
            <div>
              <h2 className="text-lg font-semibold text-gray-900 dark:text-white">{title}</h2>
              {subtitle && <p className="text-xs text-gray-500 dark:text-gray-400">{subtitle}</p>}
            </div>
          </div>
          <div className="flex items-center gap-3">
            {beforeDateContent}
            <div className="flex items-center gap-2 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg px-3 py-1.5">
              <input
                type="date"
                value={fromDate}
                onChange={(e) => onFromDateChange(e.target.value)}
                className="border-none bg-transparent focus:ring-0 text-sm text-gray-700 dark:text-gray-300 w-32"
              />
              <span className="text-gray-400 text-sm">to</span>
              <input
                type="date"
                value={toDate}
                onChange={(e) => onToDateChange(e.target.value)}
                className="border-none bg-transparent focus:ring-0 text-sm text-gray-700 dark:text-gray-300 w-32"
              />
              <button
                onClick={onApplyFilter}
                className="ml-1 px-3 py-1 bg-brandColor text-white text-sm rounded-md hover:bg-brandColorDark flex items-center gap-1"
              >
                <Filter className="h-3.5 w-3.5" />
                Apply
              </button>
            </div>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportHeader;
